import { cusAxios, PREFIX } from './main';

const filterMailing = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/mailing/filter`,
    data: data
  });
  return response;
};

const listMailing = async ({ statusList }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/mailing/list`,
    data: { statusList }
  });
  return response;
};

const createMailing = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/mailing/create`,
    data: data
  });
  return response;
};

const deleteMailing = async ({ mailingId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/mailing/delete`,
    data: { mailingId }
  });
  return response;
};

const updateMailing = async (mailingId, data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/mailing/update`,
    data: { mailingId, ...data }
  });
  return response;
};

const getInfoMailing = async (mailingId) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/mailing/get_data`,
    data: { mailingId }
  });
  return response;
};

const sendTestMailing = async ({ botId, tgUserId, messageList }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/mailing/send_test_msg`,
    data: { botId, tgUserId, messageList }
  });
  return response;
};

const getHistoryList = async ({ groupId, managerId, dateFrom, dateTo, pageNo, pageSize }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/mailing/history`,
    data: { groupId, managerId, dateFrom, dateTo, pageNo, pageSize }
  });
  return response;
};

const getManagerList = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/mailing/manager_list`,
    data: { groupId }
  });
  return response;
};

const getMessage = async ({ mailingId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/mailing/message_get`,
    data: { mailingId }
  });
  return response;
};

export const API_MAILING = {
  filter: filterMailing,
  create: createMailing,
  delete: deleteMailing,
  update: updateMailing,
  get: getInfoMailing,
  sendTest: sendTestMailing,
  message: getMessage,
  list: {
    mailing: listMailing,
    manager: getManagerList,
    history: getHistoryList
  }
};
